import { fetchData, PaginationParameters, PaginationResponse } from "@request";
import { getQueryParams } from "@request/helpers";

type Event = "new_device" | "other_event" | "security_alert" | "transfer"; // add other known event types;

export type NotificationForm = PaginationParameters<{
  event_type?: Event;
  title?: string;
  has_money?: boolean;
  start_date?: string;
  end_date?: string;
}>;

export type Notification = {
  created_at: string;
  delivery_attempts: number;
  event_type: Event;
  id: string;
  last_error: string;
  message: string;
  money?: number;
  sent_at: string;
  status: "pending" | "sent" | "failed"; // add other known statuses
  title: string;
  type: "profile" | "other_type"; // add other known types
  updated_at: string;
  user_id: string;
};

export type NotificationResponse = PaginationResponse<{
  notifications: Notification[];
  total_count: number;
}>;

export const getNotifications = async (
  userId: string,
  data: NotificationForm
) => {
  try {
    const queryParams = getQueryParams(data);

    const response = await fetchData<NotificationResponse>({
      url: `api/v1/users/${userId}/notifications?${queryParams}`,
    });

    return response;
  } catch (error) {
    console.error("Notifications failed:", error);
    throw error;
  }
};
